module.exports = __webpack_public_path__ + "static/media/no_minute_2.7b1f7ed0.jpg";